import * as v from "valibot";

import { rpcContract } from "../rpc";

export const sendChangeEmailVerificationRpcContract = rpcContract({
  name: "send-change-email-verification",
  paramsSchema: v.object({
    email: v.pipe(v.string(), v.minLength(1, "Email is required"), v.email("Invalid email format")),
    handle: v.pipe(v.string(), v.minLength(1, "Handle or user ID is required")),
  }),
  resultSchema: v.undefined(),
});

export type sendChangeEmailVerificationParams = v.InferOutput<
  (typeof sendChangeEmailVerificationRpcContract)["paramsSchema"]
>;
export type sendChangeEmailVerificationResult = v.InferOutput<
  (typeof sendChangeEmailVerificationRpcContract)["resultSchema"]
>;
